import {FC} from "react";
import styled from "styled-components";
import {OrderInformListFragment} from "./__generated__/OrderInform.fragment.generated";


const Container = styled.div`
  padding: 2.4rem;
  line-height: 130%;
  margin-top: -2.4rem;
  margin-left: -2.4rem;
  background: #e6ebef;
  margin-bottom: 2.5rem;
  width: calc(100% + 4.8rem);
`;


interface OrderInformProps {
  info: OrderInformListFragment
}

const OrderInform:FC<OrderInformProps> = ({ info }) => {
  return (
      <Container>
        <p>Информация о заказе:</p>
        <h2>{info.ads.device.title}</h2>
        <p>ID: {info.code}</p>
      </Container>
  )
}

export default OrderInform;
